
export class GetEventMinPriceAndSoldOutByEventIdsRequestDto {
  eventIds: string[];
}
